import React from "react";
import { connect } from "react-redux";
/* eslint-disable react/prop-types */

import {
  setCtrlTimeFilter,
  setSideBarTimeFilter,
  setSelectedOverlay,
  setOverlays,
  setSites,
  setSelectedSite,
  setSelectedRemoteSite,
  setAppFlowTableTime,
  setAppFlowQuery,
  setCustomTime,
  setSideBarCustomTime,
  setAccounts,
  setSelectedOverlayRoles,
  setRefreshScreen,
  setAltoProps,
  setSupportRole,
  setSsoLogoutCookie,
  setBreadCrumbs,
  setCircuitsLoader,
  setCircuitsData,
  setSitesTableAvailability,
  setOverviewError,
  setOverviewSiteLoader,
  setOverviewDeviceLoader,
  saveDeviceSiteData,
  setDeviceOverviewError,
  setAggregateAppData,
  setAppFamilySLA,
  setAppsWithFamilySLA,
  setSelectedAppList,
  setSelectedAppListLegend,
  setPostLoginNotifications,
  setPrevSelectedAppList,
  setSelectedAppListDefault,
  setTrendAnalysisFilter,
  setSidebarTableData,
  setAnomalyRefresh,
  setSdwanSiteSummary,
  setSdwanSiteSummaryError,
  setSdwanSiteSummaryLoader,
  setTalosSites,
  setTalosError,
  setTalosLoader,
  setPathAnalyticsTab,
  setMenuState,
  setTimeframeFlowsWidget,
  setPageToggle,
  setNotificationInsight,
  setNotificationInsightError,
  setNotificationInsightLoader,
  setOptimizationDonutChartData,
  setOptimizationDonutChartLoader,
  setSelectedApplications,
  setReportsDataCount,
  setAppQoeTableLoader,
} from "./actions";

const mapDispatchToProps = {
  setRefreshScreen,
  setCtrlTimeFilter,
  setSideBarTimeFilter,
  setOverlays,
  setSelectedOverlay,
  setSites,
  setSelectedSite,
  setSelectedRemoteSite,
  setAppFlowTableTime,
  setAppFlowQuery,
  setCustomTime,
  setSideBarCustomTime,
  setAccounts,
  setSelectedOverlayRoles,
  setAltoProps,
  setSupportRole,
  setSsoLogoutCookie,
  setBreadCrumbs,
  setCircuitsLoader,
  setCircuitsData,
  setSitesTableAvailability,
  setOverviewError,
  setOverviewSiteLoader,
  setOverviewDeviceLoader,
  saveDeviceSiteData,
  setDeviceOverviewError,
  setAggregateAppData,
  setAppFamilySLA,
  setAppsWithFamilySLA,
  setSelectedAppList,
  setSelectedAppListLegend,
  setPostLoginNotifications,
  setPrevSelectedAppList,
  setSelectedAppListDefault,
  setTrendAnalysisFilter,
  setSidebarTableData,
  setAnomalyRefresh,
  setSdwanSiteSummary,
  setSdwanSiteSummaryError,
  setSdwanSiteSummaryLoader,
  setTalosError,
  setTalosLoader,
  setTalosSites,
  setPathAnalyticsTab,
  setMenuState,
  setTimeframeFlowsWidget,
  setPageToggle,
  setNotificationInsight,
  setNotificationInsightError,
  setNotificationInsightLoader,
  setOptimizationDonutChartData,
  setOptimizationDonutChartLoader,
  setSelectedApplications,
  setReportsDataCount,
  setAppQoeTableLoader,
};

const mapStateToProps = (state) => {
  return {
    globalFilter: state.vanalytics.app.globalFilter,
  };
};

const AppHoc = (WrappedComponent) => {
  class PageComponent extends React.Component {
    render() {
      return (
        <WrappedComponent
          {...this.props}
          setSsoLogoutCookie={this.props.setSsoLogoutCookie}
          setRefreshScreen={this.props.setRefreshScreen}
          setCtrlTimeFilter={this.props.setCtrlTimeFilter}
          setSideBarTimeFilter={this.props.setSideBarTimeFilter}
          setOverlays={this.props.setOverlays}
          setSelectedOverlay={this.props.setSelectedOverlay}
          setSites={this.props.setSites}
          setSelectedSite={this.props.setSelectedSite}
          setSelectedRemoteSite={this.props.setSelectedRemoteSite}
          setAppFlowTableTime={this.props.setAppFlowTableTime}
          setAppFlowQuery={this.props.setAppFlowQuery}
          setCustomTime={this.props.setCustomTime}
          setSideBarCustomTime={this.props.setSideBarCustomTime}
          setAccounts={this.props.setAccounts}
          setSelectedOverlayRoles={this.props.setSelectedOverlayRoles}
          setAltoProps={this.props.setAltoProps}
          setSupportRole={this.props.setSupportRole}
          setBreadCrumbs={this.props.setBreadCrumbs}
          setCircuitsLoader={this.props.setCircuitsLoader}
          setCircuitsData={this.props.setCircuitsData}
          setSitesTableAvailability={this.props.setSitesTableAvailability}
          setOverviewError={this.props.setOverviewError}
          setOverviewSiteLoader={this.props.setOverviewSiteLoader}
          setOverviewDeviceLoader={this.props.setOverviewDeviceLoader}
          saveDeviceSiteData={this.props.saveDeviceSiteData}
          setDeviceOverviewError={this.props.setDeviceOverviewError}
          setAggregateAppData={this.props.setAggregateAppData}
          setAppFamilySLA={this.props.setAppFamilySLA}
          setAppsWithFamilySLA={this.props.setAppsWithFamilySLA}
          setSelectedAppList={this.props.setSelectedAppList}
          setSelectedAppListLegend={this.props.setSelectedAppListLegend}
          setPostLoginNotifications={this.props.setPostLoginNotifications}
          setPrevSelectedAppList={this.props.setPrevSelectedAppList}
          setTrendAnalysisFilter={this.props.setTrendAnalysisFilter}
          setSidebarTableData={this.props.setSidebarTableData}
          setAnomalyRefresh={this.props.setAnomalyRefresh}
          setSdwanSiteSummary={this.props.setSdwanSiteSummary}
          setSdwanSiteSummaryError={this.props.setSdwanSiteSummaryError}
          setSdwanSiteSummaryLoader={this.props.setSdwanSiteSummaryLoader}
          setTalosSites={this.props.setTalosSites}
          setTalosError={this.props.setTalosError}
          setTalosLoader={this.props.setTalosLoader}
          setPathAnalyticsTab={this.props.setPathAnalyticsTab}
          setMenuState={this.props.setMenuState}
          setTimeframeFlowsWidget={this.props.setTimeframeFlowsWidget}
          setPageToggle={this.props.setPageToggle}
          setNotificationInsight={this.props.setNotificationInsight}
          setNotificationInsightError={this.props.setNotificationInsightError}
          setNotificationInsightLoader={this.props.setNotificationInsightLoader}
          setOptimizationDonutChartData={
            this.props.setOptimizationDonutChartData
          }
          setOptimizationDonutChartLoader={
            this.props.setOptimizationDonutChartLoader
          }
          setSelectedApplications={this.props.setSelectedApplications}
          setReportsDataCount={this.props.setReportsDataCount}
          setAppQoeTableLoader={this.props.setAppQoeTableLoader}
        />
      );
    }
  }

  return (
    connect(mapStateToProps, mapDispatchToProps)(PageComponent)
  );
};

export default AppHoc;
